import React from 'react';
import { CheckIcon } from 'lucide-react';
export interface Step {
  id: string;
  label: string;
  status: 'complete' | 'current' | 'upcoming' | 'error';
}
interface StepperProps {
  steps: Step[];
  onStepClick?: (id: string) => void;
  orientation?: 'horizontal' | 'vertical';
}
export const Stepper: React.FC<StepperProps> = ({
  steps,
  onStepClick,
  orientation = 'horizontal'
}) => {
  return <div className={`flex ${orientation === 'vertical' ? 'flex-col space-y-6' : 'items-center justify-between w-full'}`} data-id="element-228">
      {steps.map((step, index) => <div key={step.id} className={`flex ${orientation === 'vertical' ? 'items-start' : 'items-center flex-1'}`} data-id="element-229">
          <div className={`flex items-center cursor-pointer group ${orientation === 'vertical' ? '' : 'flex-col'}`} onClick={() => onStepClick && onStepClick(step.id)} data-id="element-230">
            <div className={`
              flex items-center justify-center w-8 h-8 rounded-full border-2 font-semibold text-sm transition-colors
              ${step.status === 'complete' ? 'bg-fpg-navy border-fpg-navy text-white' : ''}
              ${step.status === 'current' ? 'border-fpg-navy text-fpg-navy bg-white' : ''}
              ${step.status === 'upcoming' ? 'border-border-strong text-text-tertiary bg-white' : ''}
              ${step.status === 'error' ? 'border-status-error text-status-error bg-white' : ''}
            `} data-id="element-231">
              {step.status === 'complete' ? <CheckIcon className="w-5 h-5" data-id="element-232" /> : index + 1}
            </div>
            <span className={`
              ${orientation === 'vertical' ? 'ml-3 mt-1' : 'mt-2 text-center'} text-sm font-medium
              ${step.status === 'current' ? 'text-fpg-navy' : 'text-text-secondary'}
            `} data-id="element-233">
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && orientation === 'horizontal' && <div className={`flex-1 h-0.5 mx-4 ${steps[index].status === 'complete' ? 'bg-fpg-navy' : 'bg-border-light'}`} data-id="element-234" />}
        </div>)}
    </div>;
};